export const ERRORS = {
    'auth_email_api': {
        'server_error': 'We could not send you an email at this time. Please try again later.',
        'invalid_to': 'Please check the email address for typos.',
    },
    'auth': {
        'generic': 'Server error. Please, try again later.',
        'otp_expired': 'The code is incorrect or expired. Please check for typos or resend the code.'
    }
};